module.exports = __webpack_public_path__ + "static/media/permissions-logo.19f48ea9.png";